import ContractsCargoTaxiDetails from "../../../../../common/services/contracts/cargo-taxi/details/contracts-cargo-taxi-details";
import TaxiCargoContractEditFormData from "./types/taxi-cargo-contract-edit-form-data";

const create = (
  data: ContractsCargoTaxiDetails,
): TaxiCargoContractEditFormData => {
  return {
    cancelOrderByTaxiAllowed: data.cancelByTaxiAllowed,
    contactPassengerAfterMinutes: data.contactPassengerAfterMinutes,
    editOrderByTaxiAllowed: data.editByTaxiAllowed,
    isActive: data.isActive,
    autoApprovalMinDistance: data.autoApprovalMinDistance,
    autoApprovalSwitch: data.autoApprovalSwitch,
    autoApprovalMinTime: data.autoApprovalMinTime,
    approvalDeadlineSwitch: data.approvalDeadlineSwitch,
    approvalDeadlineTime: data.approvalDeadlineTime,
  };
};

const taxiCargoContractEditFormFactory = {
  create,
};

export default taxiCargoContractEditFormFactory;
